import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import DialogRoot from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";

import { Button, colorFirm } from "../../Buttons/Button/Button";
import { IconButtonBg } from "../../Buttons/IconButtonBg/IconButtonBg";

import "./FormDialog.scss";

export const FormDialog = ({
    isOpen,
    layout = "table",
    confirmButtonText = "Save",
    title,
    initialValues,
    fullWidth,
    popupWidth,
    withControls,
    disableActionBtn,
    isLoading,
    form,
    table,
    onClose = () => {},
    onSubmit = () => {}
}) => (
    <DialogRoot
        classes={{
            root: "form-dialog",
            paper: classNames(
                "form-dialog__inner",
                { "form-dialog__inner--full-width": fullWidth },
                `form-dialog__inner--custom-width-${popupWidth}`
            )
        }}
        open={isOpen}
        onClose={onClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
    >
        <Form
            onSubmit={onSubmit}
            mutators={{ ...arrayMutators }}
            initialValues={initialValues}
            render={(formProps) => {
                const isDisabledBtn =
                        disableActionBtn ?
                            formProps.values && !Object.values(formProps.values).length :
                            false;

                return (
                    <form
                        className={"form-dialog__form-body"}
                        onSubmit={event => {
                            if(formProps.handleSubmit.then){
                                formProps.handleSubmit(event).then(formProps.form.reset);
                            }else{
                                formProps.handleSubmit(event);
                            }
                        }}
                    >
                        <div className="form-dialog__title">
                            <h2>{title}</h2>

                            <IconButtonBg onClick={onClose}>
                                <CloseIcon />
                            </IconButtonBg>
                        </div>

                        <div className="form-dialog__form">
                            { React.Children.map(form, child => React.cloneElement(child, { formProps })) }
                        </div>

                        {
                            layout === "table" && (
                                <>
                                    <div className="form-dialog__controls">
                                        {
                                            withControls && (
                                                <Button
                                                    className={"form-dialog__controls-btn"}
                                                    disabled={isDisabledBtn}
                                                    isLoading={isLoading}
                                                    colorFirm={colorFirm.firm2}
                                                    type={"submit"}
                                                >
                                                    {confirmButtonText}
                                                </Button>
                                            )
                                        }
                                    </div>


                                    <div className="form-dialog__table">
                                        {table}
                                    </div>
                                </>
                            )
                        }

                        <div className="form-dialog__controls">
                            {
                                layout === "default" && (
                                    <Button
                                        className={"form-dialog__controls-btn"}
                                        disabled={isDisabledBtn}
                                        isLoading={isLoading}
                                        colorFirm={colorFirm.firm2}
                                        type={"submit"}
                                    >
                                        {confirmButtonText}
                                    </Button>
                                )
                            }

                            <Button
                                className={"validators-object-structure__btn"}
                                colorFirm={colorFirm.firm3}
                                disabled={isLoading}
                                onClick={onClose}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                );
            }}
        />
    </DialogRoot>
);

FormDialog.defaultProps = {
    disableActionBtn: false,
    fullWidth: false,
    withControls: true
};

FormDialog.propTypes = {
    classes: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    fullWidth: PropTypes.bool,
    title: PropTypes.string.isRequired,
    withControls: PropTypes.bool,
    popupWidth: PropTypes.number,
    disableActionBtn: PropTypes.bool,
    children: PropTypes.any,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func
};
